import type { Journey } from '@common/types/Journey'
import { safeProp } from '@lc/libutils'
import {
	createSlice,
	type PayloadAction,
	type WithSlice,
} from '@reduxjs/toolkit'
import { reducer } from './store'

export type JourneySlice = {
	status: 'loading' | 'ready' | 'error'
	journeys: Journey[]
	hoveredJourney: string | null
	error?: string
}
export const defaultJourneyStates: JourneySlice = {
	status: 'ready',
	journeys: [],
	hoveredJourney: null,
}

declare module './store' {
	// eslint-disable-next-line @typescript-eslint/no-empty-object-type
	export interface LoadedSlices extends WithSlice<typeof journeySlice> {}
}

export const journeySlice = createSlice({
	name: 'journeys',
	initialState: defaultJourneyStates,
	reducers: {
		setJourneys: (state, action: PayloadAction<Journey[]>) => {
			state.status = 'ready'
			state.journeys = action.payload
			state.error = undefined
		},
		setHoveredJourney: (state, action: PayloadAction<string>) => {
			state.hoveredJourney = action.payload
		},
		setJourneysLoading: state => {
			state.status = 'loading'
			state.error = undefined
		},
		setJourneysError: (state, action: PayloadAction<string>) => {
			state.status = 'error'
			state.error = action.payload
		},
	},
	selectors: {
		getJourney: (state, id: string): Journey | undefined => {
			const journey = state.journeys[safeProp(id) as keyof Journey[]]
			return journey as Journey
		},
	},
})

export const {
	reducer: journeyReducer,
	actions: {
		setJourneys,
		setJourneysLoading,
		setJourneysError,
		setHoveredJourney,
	},
	selectors: { getJourney },
	selectSlice: selectJourneySlice,
} = journeySlice.injectInto(reducer)
